import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UIModule } from './ui/ui.module';

import { WidgetModule } from './widget/widget.module';
import { ShortenNoPointsPipe } from '../shortenNoPoints.pipe';
import { ShortenPipe } from '../shorten.pipe';

@NgModule({
  declarations: [
    ShortenNoPointsPipe,
    ShortenPipe
  ],
  imports: [
    CommonModule,
    UIModule,
    WidgetModule
  ],
  exports: [
    /* then export it */
    ShortenNoPointsPipe,
    ShortenPipe
  ]
})

export class SharedModule { }
